module.exports = __webpack_public_path__ + "static/media/tasting.d117ca58.svg";